import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { SwooshAccent } from '../ui/DecorativeElements';

const { FiCheckCircle, FiBookOpen, FiActivity, FiStar, FiHeart, FiTrendingUp } = FiIcons;

const BENEFITS = [
  { title: 'Certified Trainers', icon: FiStar, desc: 'Industry veterans with official accreditation.' },
  { title: 'Practical Learning', icon: FiBookOpen, desc: 'Hands-on scenarios mirroring real workplaces.' },
  { title: 'Industry Compliance', icon: FiCheckCircle, desc: 'Strict adherence to national safety regulations.' },
  { title: 'Experienced Team', icon: FiActivity, desc: 'Decades of combined workforce training expertise.' },
  { title: 'Employer Support', icon: FiHeart, desc: 'Dedicated consultation and administrative assistance.' },
  { title: 'Workforce Development', icon: FiTrendingUp, desc: 'Focus on continuous growth and skill enhancement.' },
];

const WhyChoose = () => {
  return (
    <section className="py-24 bg-alpha-navy relative overflow-hidden text-white">
      {/* Background Swoosh connecting elements visually */}
      <SwooshAccent className="top-1/2 -translate-y-1/2 left-0 w-[200%] h-96 text-white/5" />
      
      <div className="container mx-auto px-6 max-w-7xl relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-alpha-green font-semibold tracking-wider uppercase mb-2 text-sm">The Alpha Advantage</h2>
          <h3 className="text-3xl md:text-4xl font-bold mb-4">Why Partner With Us</h3>
          <p className="text-alpha-grayLight/80 text-lg">
            We don't just deliver courses; we build sustainable safety cultures and competent workforces.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
          {BENEFITS.map((benefit, index) => (
            <motion.div 
              key={benefit.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="flex items-start gap-4 relative group"
            >
              <div className="w-12 h-12 rounded-full bg-alpha-green/20 border border-alpha-green/30 flex items-center justify-center flex-shrink-0 group-hover:bg-alpha-green transition-colors duration-300">
                <SafeIcon icon={benefit.icon} className="text-xl text-alpha-green group-hover:text-white transition-colors" />
              </div>
              <div>
                <h4 className="text-xl font-bold mb-2">{benefit.title}</h4>
                <p className="text-alpha-grayLight/70">{benefit.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;